import axios from "axios";
// import store from "@/store"; // Keycloak token — comment ไว้ใช้ภายหลัง

const BASE_API = process.env.VUE_APP_BASE_API;
const SALT = process.env.VUE_APP_API_TOKEN_SALT;

// Endpoints ที่เปิดใช้ token — เพิ่ม path เข้า array เมื่อ backend พร้อม
const TOKEN_ENABLED_ENDPOINTS = [
  "member/getReportUserProgress/",
  "household/getHouseSurvey",
  "household/getHouseSurveyById",
  "household/getHouseSurveySummaryReport",
  "household/getHouseSurveySolActReport",
  "member/getMemberSurvey",
  "member/getMemberSurveyById",
  "member/getReport1UserStats/",
  "family/getFamilySurvey",
  "family/getFamilySurveyById",
  "dc/personalInfo",
  "dc/dep",
  "dc/send2Ext",
  "dc/csg/v1"
];

/**
 * สร้าง time-based hash token
 * token = SHA-256( String(unixMinutes) + salt )
 * ดู spec: TIME-BASED-TOKEN-SPEC.md
 */
async function generateToken() {
  const unixMinutes = Math.floor(Date.now() / 60000);
  const input = String(unixMinutes) + SALT;

  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

axios.interceptors.request.use(
  async (config) => {
    const url = config.url || "";
    const isInternalApi =
      url.startsWith(BASE_API) ||
      (!url.startsWith("http://") && !url.startsWith("https://"));

    // ส่ง token เฉพาะ endpoint ที่อยู่ใน whitelist
    const shouldSendToken = isInternalApi &&
      TOKEN_ENABLED_ENDPOINTS.some((ep) => url.includes(ep));

    if (shouldSendToken) {
      const token = await generateToken();

      // --- Keycloak token (comment ไว้ใช้ภายหลัง) ---
      // const token = store.getters["userAuth/getToken"];
      // if (token) {
      // --- end Keycloak token ---

      const method = (config.method || "get").toLowerCase();

      if (method === "get" || method === "delete" || method === "head") {
        // GET/DELETE/HEAD → ส่ง token ผ่าน query string
        if (!config.params) config.params = {};
        config.params.token = token;
      } else {
        // POST/PUT/PATCH → ส่ง token ผ่าน body
        if (config.data && typeof config.data === "object" && !(config.data instanceof FormData)) {
          config.data.token = token;
        } else if (!config.data) {
          config.data = { token };
        }
        // FormData (file upload) → ส่ง token ผ่าน query string แทน
        if (config.data instanceof FormData) {
          if (!config.params) config.params = {};
          config.params.token = token;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);
